import { render } from "./FlowSaveClose.vue?vue&type=template&id=4dc2d8ff"
import script from "./FlowSaveClose.vue?vue&type=script&lang=js"
export * from "./FlowSaveClose.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__